import React from 'react';
import { Grid, Typography, Card, CardContent, Box } from '@mui/material';
import { motion } from 'framer-motion';

const courseData = [
  { id: 1, title: 'Computer Science' },
  { id: 2, title: 'Statistics' },
  { id: 3, title: 'Entrepreneurship' },
  { id: 4, title: 'Finance & Banking' },
  { id: 5, title: 'Legal Studies' },
];

const Courses = () => {
  return (
    <Box sx={{ width: '100%', backgroundColor: 'var(--primary-dark)', py: 6 }}>
      <Typography
        variant="h3"
        sx={{
          color: '#fff',
          textAlign: 'center',
          mb: 6,
          fontWeight: 800,
          fontSize: { xs: '32px', sm: '36px', md: '44px' },
        }}
      >
        Optional Subjects in Commerce Stream
      </Typography>

      <Grid container spacing={3} justifyContent="center" alignItems="center" maxWidth="1200px" mx="auto">
        {courseData.map((course, index) => (
          <Grid item xs={12} sm={6} md={2.4} key={course.id}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.5 }}
            >
              <Card
                className="glass-card"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  borderRadius: '16px',
                  padding: 3,
                  minHeight: '140px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  color: '#fff',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    background: 'rgba(255, 255, 255, 0.15)',
                    borderColor: 'var(--secondary-color)',
                  }
                }}
              >
                <CardContent sx={{ width: '100%', padding: '0 !important' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, fontSize: { xs: '18px', md: '20px' }, lineHeight: 1.4 }}>
                    {course.title}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Courses;